import { Component } from "react"
import React from 'react'

//Website Base URL
//const WebsiteBaseUrl = "  http://127.0.0.1:3014/property-details/";
const WebsiteBaseUrl = 'https://askmerealty.in/property-details/';

//Admin Base URL
//const BaseUrl = "https://localhost:44371";
const BaseUrl = 'https://amrapi.askmerealty.in/';

//Base URL + Controller Names

const ZSections = BaseUrl + "/ZSections/";

const SZType = BaseUrl + "/SZType/";

const CMenu = BaseUrl + "/CMenu/";

const AAuthorizations = BaseUrl + "/AAuthorizations/";

const UserRole = BaseUrl + "/UserRole/";

const Ausers = BaseUrl + "/Ausers/";

const AUserProfile = BaseUrl + "/AUserProfile/";

const ActivityLog = BaseUrl + "/ActivityLog/"

const Subscription = BaseUrl + "/Subscription/"

const Property = BaseUrl + "/Property/"

const NewProperty = BaseUrl + "/NewProperty/"

const VendorLogin = BaseUrl + "/VendorLogin/"

const HeroSection = BaseUrl + "/HeroSection/"

const BannerSection = BaseUrl + "/BannerSection/"

const PageBanner = BaseUrl + "/PageBanner/"

const PageURLMaster = BaseUrl + "/PageURLMaster/"

const DetailPage = BaseUrl + "/DetailPage/"

const TOC = BaseUrl + "/TOC/"

const FAQ = BaseUrl + "/FAQ/"

const Meta = BaseUrl + "/Meta/"

const NewsLetter = BaseUrl + "/NewsLetter/"

const Tag = BaseUrl + "/Tag/"

const LinkPage = BaseUrl + "/LinkPage/"

const AState = BaseUrl + "/State/"

const Cities = BaseUrl + "/City/"

const ContactUs = BaseUrl + "/ContactUs/"
const Enquiry = BaseUrl + "/Enquiry/"
const Blogs = BaseUrl + "/Blogs/"
const AMRDetail = BaseUrl + "/AMRDetail/"
const WEBFAQ = BaseUrl + "/WEBFAQ/"
const TrustedPartner = BaseUrl + "/TrustedPartner/"
const Testimonial = BaseUrl + "/Testimonial/"
const Policies = BaseUrl + "/Policies/"             
const AboutUs = BaseUrl + "/AboutUs/"
const Furnishing = BaseUrl + "/FurnishingMaster/"

export const APIUrl = {
    WebsiteBaseUrl,
    BaseUrl,
    ZSections,
    SZType,
    CMenu,
    AAuthorizations,
    UserRole,
    Ausers,
    ActivityLog,
    AUserProfile,
    Subscription,
    Property,
    NewProperty,    
    VendorLogin,
    HeroSection,
    BannerSection,
    PageBanner,
    PageURLMaster,
    DetailPage,
    TOC,
    FAQ,
    Meta,
    Tag,
    LinkPage,
    State: AState,
    Cities,
    ContactUs,
    Enquiry,
    Blogs,
    AMRDetail,
    WEBFAQ,
    TrustedPartner,
    Testimonial,
    Policies,
    NewsLetter
    ,
    AboutUs,
    Furnishing
}

